<template>
    <div class="mt-0">
        <div class="row p-2 mt-3" id="lower-div">
            <div class="card mb-4">
                <div v-loading="loading">
                    <Table @get-data="GetExceptionTypes" :data="data"></Table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Table from "./Components/Table.vue";

export default {
    components: {
        Table
    },
    data() {
        return {
            firstVis: true,
            loading: null,
            data:[
                {
                    check: true,
                    value: "Siz tibbi müayinədən keçmisiniz (zəhmət olmasa tarixi qeyd edərdiniz)? Hər hansı kənarlaşmalar müəyyən edilibmi?"
                },
                {
                    value: "Siz dərman preparatları qəbul edirsinizmi? Əgər cavab müsbətdirsə, dərmanın adını qeyd edərdiniz."
                },
                {
                    value: "Siz pivə, çaxır və spirtli içkilər qəbul edirsinizmi? Əgər cavab müsbətdirsə, onda gün ərzində qəbul edilən içkilərin sayını göstərin."
                },
                {
                    check: true,
                    value: "Sizin sənətiniz təhlükəli qiymətləndirilən əmək fəaliyyəti və ya məşğuliyyətlə (idman...) bağlıdırmı? Məsələn: aviasiya və ya avtomobil yarışları?"
                },
                {
                    check: false,
                    value: "Sizin hər hansı xroniki xəstəliyiniz (diabet, ürək-damar, tənəffüs, mədə-bağırsaq və s.) varmı?"
                },
                {
                    check: false,
                    value: "Siz son 5 il ərzində əməliyyat və ya hospitalizasiya olunmusunuzmu?"
                },
                {
                    check: false,
                    value: "Sizdə allergiyalar (dərman, qida, toz, polen və s.) varmı?"
                },
                {
                    check: true,
                    value: "Siz narkotik vasitələr qəbul etmisinizmi və ya hazırda qəbul edirsinizmi?"
                }
            ],
            navNumber: 1
        }
    },
}
</script>